import { Text } from "@mantine/core";
import { PackageIcon } from "@phosphor-icons/react";
import { useTranslation } from "react-i18next";
import useSWR from "swr";
import { ReturnAnalyticsApi } from "../../../apis";
import { ListState } from "../../ui";
import { DetailCard } from "../detail-card";
import { BarList } from "./bar-list";

interface IProps {
  dateFromIso?: string;
  dateToIso?  : string;
}

export function RefundChannelBreakdownChart({ dateFromIso, dateToIso }: IProps) {
  const { t } = useTranslation("returns");
  const { data, error, mutate } = useSWR(
    ["returns.breakdown.refund-method", dateFromIso, dateToIso],
    () => ReturnAnalyticsApi.breakdown({ dimension: "refund-method", dateFrom: dateFromIso, dateTo: dateToIso }),
    { revalidateOnFocus: false }
  );

  // Returns without a refund channel yet (bucket null) are not a channel.
  const items = (data?.buckets ?? [])
    .filter((b) => b.bucket && b.bucket !== "UNSET")
    .map((b) => ({ key: b.bucket as string, label: t(`refundMethod.${b.bucket}`, { defaultValue: "-" }), value: b.count }));
  const total = items.reduce((s, x) => s + x.value, 0);

  return (
    <DetailCard title={t("dashboard.refundChannel.title")}>
      {error && !data ? (
        <ListState state="error" onRetry={() => mutate()} />
      ) : total === 0 ? (
        <ListState state="empty" icon={<PackageIcon size={24} />} title={t("common.noData")} description={t("dashboard.refundChannel.empty")} />
      ) : (
        <>
          <BarList items={items} />
          <Text size="sm" c="var(--nw-text-2)" mt="sm">{t("dashboard.chartLabel.returns", { count: total })}</Text>
        </>
      )}
    </DetailCard>
  );
}
